"use client";

import {
  AnimatePresence,
  domAnimation,
  LazyMotion as FramerLazyMotion,
  m,
} from "framer-motion";

export function LazyMotion(
  props: Omit<React.ComponentProps<typeof FramerLazyMotion>, "features">
) {
  return <FramerLazyMotion features={domAnimation} {...props} />;
}

// https://github.com/framer/motion/issues/2054#issuecomment-1491568547
export const MotionLi = m.li;
export const MotionDiv = m.div;
export const MotionH1 = m.h1;
export const MotionH3 = m.h3;
export const MotionP = m.p;
export const MotionSpan = m.span;
export { AnimatePresence };
